import '@/components/base'
import '@/directives/index'
import '@/styles/main.scss'
import { Settings } from 'luxon'
import Vue from 'vue'
import Toasted from 'vue-toasted'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Settings.defaultLocale = 'fr'

Vue.use(Toasted)

export default function createVueApp({firebaseUser, user, roles}) {
  addPropertiesOnVuejsPrototype({ firebaseUser, user, roles })

  return new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

function addPropertiesOnVuejsPrototype({ firebaseUser, user, roles }) {
  Vue.prototype.$user = firebaseUser
  Vue.prototype.$userInfos = user
  Vue.prototype.$roles = roles
}

store.subscribe((mutation, state) => localStorage.setItem('supply.context', JSON.stringify(state.context)))
